import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  IPermission,
  IGroupPermission,
  IGroupPermissionProps,
} from "./GroupPermissionInterfaces";

export default function GroupPermission({
  group,
  permissions,
  setPermissions,
}: IGroupPermissionProps) {
  const [toggleRender, setToggleRender] = useState<boolean>(false);
  const [localPermission, setLocalPermission] =
    useState<IPermission[]>(permissions);

  useEffect(() => {
    const fetchData = async () => {
      let permissions = await getPermissions();
      await getGroupPermissionsByGroup(permissions);
    };

    fetchData();
  }, []);

  const getPermissions = async () => {
    try {
      let response = await blogFetch.get(`/permission`);
      let data = response.data;
      setLocalPermission(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getGroupPermissionsByGroup = async (permissions: IPermission[]) => {
    try {
      let response = await blogFetch.get(`/groupPermissions/${group.group_Id}`);
      let data: IGroupPermission[] = response.data;
      let list: any[] = [];

      for (let i = 0; i < data.length; i++) {
        list.push(data[i].permission.permissions_Id);
      }

      const newCheckList = permissions.map((item) => {
        const container = item;
        if (list.includes(item.permissions_Id)) {
          container["checked"] = true;
        } else {
          container["checked"] = false;
        }

        return container;
      });
   
      setLocalPermission(newCheckList);
      setToggleRender(!toggleRender);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newCheckList = localPermission;
    for (let i = 0; i < newCheckList.length; i++) {
      if (newCheckList[i].permissions_Id?.toString() === event.target.value) {
        newCheckList[i].checked = event.target.checked;
        break;
      }
    }
    setPermissions(newCheckList);
    setLocalPermission(newCheckList);
    setToggleRender(!toggleRender);
  };

  const renderPermissions = () => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: 6,
      }}
    >
      {!!localPermission &&
        localPermission.map((permission) => {
          const isChecked = !!permission.checked;
          return (
            <FormControlLabel
              key={permission.permissions_Id}
              sx={{
                margin: 0,
                padding: "4px 8px",
                borderRadius: "6px",
                border: isChecked
                  ? "1.5px solid #9ed6de"
                  : "1.5px solid #e0e0e0",
                backgroundColor: isChecked ? "#eef8fa" : "#fafafa",
                transition: "all 0.15s",
                "&:hover": {
                  borderColor: "#9ed6de",
                  backgroundColor: isChecked ? "#e0f2f5" : "#f0f0f0",
                },
                "& .MuiFormControlLabel-label": {
                  fontSize: 13,
                  fontWeight: isChecked ? 500 : 400,
                  color: isChecked ? "#2e7d82" : "#555",
                  userSelect: "none",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              }}
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={handleCheck}
                  name={permission.permissions_Description}
                  value={permission.permissions_Id}
                  size="small"
                  sx={{
                    color: "#bbb",
                    "&.Mui-checked": { color: "#5bb5bd" },
                  }}
                />
              }
              label={permission.permissions_Description}
            />
          );
        })}
    </div>
  );

  return (
    <div>
      <p
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: "#444",
          marginBottom: 10,
        }}
      >
        Permissões
      </p>
      {toggleRender ? renderPermissions() : <section>{renderPermissions()}</section>}
    </div>
  );
}
